import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=4425e7f4&scoped=true"
import script from "./page2.vue?vue&type=script&lang=js"
export * from "./page2.vue?vue&type=script&lang=js"
import style0 from "./page2.vue?vue&type=style&index=0&id=4425e7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4425e7f4",
  null
  
)

export default component.exports